import all from '../all';
import common from './common.json';

const lang = {
  all,
  common,
};
export default lang;
